<template>
  <div class="person">
    <div class="container">
      <div class="nav">
        <h4>个人中心</h4>
        <img class="avatar" :src="userBaseInfo.headImg" alt="">
        <p class="name">{{userBaseInfo.nickName}}</p>
        <p class="rank">
          <img src="../../assets/images/person/rank.png" alt="">
          <span>等级：</span>
          <span class="grade">v5</span>
        </p>
        <ul class="list">
          <li v-for="(item, index) in info" :key="index" class="item" @click="handleClick(index)">
            <router-link :to="item.url">
              <img :src="item.icon" alt="">
              <span>{{item.text}}</span>
              <p class="line" v-if="$route.path.includes(item.url)"></p>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="right">
        <keep-alive>
          <router-view  v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>

    </div>

  </div>
</template>

<script>
import {reqUserInfo} from '../../api'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      info: [
        {
          icon: require('../../assets/images/person/ziliao.png'),
          text: '我的资料',
          url: '/person/datum'
        },
        {
          icon: require('../../assets/images/person/qianbao.png'),
          text: '我的钱包',
          url: '/person/wallet'
        },
        {
          icon: require('../../assets/images/person/youhuiquan.png'),
          text: '我的优惠券',
          url: '/person/coupon'
        },
        {
          icon: require('../../assets/images/person/dingdan.png'),
          text: '我的订单',
          url: '/person/order'
        },
        {
          icon: require('../../assets/images/person/jiuzhenren.png'),
          text: '我的就诊人',
          url: '/person/patient'
        },
        {
          icon: require('../../assets/images/person/chengke.png'),
          text: '我的乘客',
          url: '/person/passenger'
        },
        {
          icon: require('../../assets/images/person/fapiao.png'),
          text: '我的发票',
          url: '/person/bill'
        },
        {
          icon: require('../../assets/images/person/xiaoxi.png'),
          text: '我的消息',
          url: '/person/info'
        },
        {
          icon: require('../../assets/images/person/kuaidi.png'),
          text: '开通一线快递高级版',
          url: '/person/express'
        },
        {
          icon: require('../../assets/images/person/dizhi.png'),
          text: '地址管理',
          url: '/person/address'
        }

      ],
      i: 0
    }
  },
  mounted() {
    this.$store.dispatch('recordUserBaseInfo')
  },
  methods: {
    handleClick (i) {
      this.i = i
    },
  },
  computed: {
    ...mapState(['userBaseInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
.person{
  margin-bottom: 60px;
  .container{
    display: flex;
    justify-content: space-between;
    .nav{
      width: 240px;
      height: max-content;
      padding:20px 0;
      box-shadow:0px 3px 27px 0px rgba(0, 0, 0, 0.1);
      h4{
        font-size:18px;
        font-weight: bold;
        text-align: center;
      }
      .avatar{
        display: block;
        width: 98px;
        height: 98px;
        margin: 16px auto;
        border-radius:50%;
        background: #eee;
      }
      .name{
        font-size: 16px;
        font-weight: bold;
        margin-top:10px;
        text-align: center;
      }
      .rank{
        margin-top:10px;
        text-align: center;
        img{
          vertical-align: middle;
        }
        .grade{
          font-weight: bold;
          color:#F08303;
          font-size:18px;
        }
      }
      .list{
        margin-top:24px;
        .item{
          position: relative;
          line-height: 50px;
          cursor: pointer;
          a{
            display: block;
            width: 100%;
            height: 100%;
            img{
              margin:0 13px 0 34px;
            }
            span{
              font-size: 16px;
            }
            .line{
              position: absolute;
              top: 0;
              left: 0;
              width: 4px;
              height: 100%;
              background: #2FA1DE;
            }
          }

        }
      }
    }
    .right{
      width: 900px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Person.vue